module.exports = __webpack_public_path__ + "img/zaken_no.8ee8b4d7.png";